import { gql } from '@apollo/client';

export const SIMPLR_ACCOUNT_FIELDS_FRAGMENT = gql`
  fragment SimplrAccountFields on SimplrAccount {
    id
    objectId: id
    escalateEmail
    minimumExpertRank
    accountStatus
  }
`;
